<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.disabled" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="disabled" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.readonly" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="readonly" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.dense" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="dense" />
        </test-toolbar>
      </flex-col>
      <flex-col sm24 md12 equal-height :span="8" :spacing="8" v-for="(rating, index) in ratings" :key="index">
        <card :dark="$root.dark" full-height>
          <card-text align="center">
            <paragraph :class="['mt-2']" v-html="rating.title" />
            <divider :class="['mb-2']" />
            <rating
              @input="onInput($event)"
              v-model="rating.value"
              :name="`rating-${index}`"
              :dense="dense"
              :size="rating.size"
              :readonly="readonly"
              :disabled="disabled"
              :color="rating.color"
              :color-lightness="500"
              :icon="rating.icon"
              :items="rating.items" />
          </card-text>
          <divider />
          <card-actions align="center">
            <code-chunk :pre="false">v-model: {{ rating.value }}</code-chunk>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageRating',
  mixins: [
    methods
  ],
  data () {
    return {
      ratings: [],
      dense: false,
      readonly: false,
      disabled: false
    }
  },
  mounted () {
    this.getExternalData('rating.json', 'ratings')
  },
  methods: {
    onInput ($event) {
      this.log('input', 'rating', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/rating.vue